import React from 'react';
import type { DiscountDetails } from '../../../../store/NCDAndDiscountedPros.types';
import { INCENTIVES_DISCOUNT_CODE } from '../constants';
import ClassicIncentivesBanner from './ClassicIncentivesBanner';
import DiscountBanner from './DiscountBanner';

export type IncentivesBannerProps = {
  providerName?: string | null;
  discountDetails: DiscountDetails;
  renderMoreDetailsCta: (onDismiss: () => void) => React.ReactNode | React.ReactNode[];
  /** Background color of banner */
  color?: string;
};

const IncentivesBanner: React.FCWithChildren<IncentivesBannerProps> = ({
  providerName,
  discountDetails,
  renderMoreDetailsCta = () => null,
  color,
}: IncentivesBannerProps) => {
  if (discountDetails?.discountCode === INCENTIVES_DISCOUNT_CODE) {
    return (
      <ClassicIncentivesBanner
        color={color}
        providerName={providerName}
        discountDetails={discountDetails}
        renderMoreDetailsCta={renderMoreDetailsCta}
      />
    );
  }

  return (
    <DiscountBanner
      discountDetails={discountDetails}
      renderMoreDetailsCta={renderMoreDetailsCta}
      providerName={providerName}
    />
  );
};

export default IncentivesBanner;
